module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "seller"
  }, [_h('div', {
    staticClass: "seller-content"
  }, [_h('div', {
    staticClass: "overview"
  }, [_h('h1', {
    staticClass: "title"
  }, [_vm._s(_vm.seller.name)]), " ", _h('div', {
    staticClass: "desc border-1px"
  }, [_h('star', {
    attrs: {
      "size": 36,
      "score": _vm.seller.score
    }
  }), " ", _h('span', {
    staticClass: "text"
  }, ["(" + _vm._s(_vm.seller.ratingCount) + ")"]), " ", _h('span', {
    staticClass: "text"
  }, ["月售" + _vm._s(_vm.seller.sellCount) + "单"])]), " ", _h('ul', {
    staticClass: "remark"
  }, [_h('li', {
    staticClass: "block"
  }, [_h('h2', ["起送价"]), " ", _h('div', {
    staticClass: "content"
  }, [_h('span', {
    staticClass: "stress"
  }, [_vm._s(_vm.seller.minPrice)]), "元\n          "])]), " ", _h('li', {
    staticClass: "block"
  }, [_h('h2', ["商家配送"]), " ", _h('div', {
    staticClass: "content"
  }, [_h('span', {
    staticClass: "stress"
  }, [_vm._s(_vm.seller.deliveryPrice)]), "元\n          "])]), " ", _h('li', {
    staticClass: "block"
  }, [_h('h2', ["平均配送时间"]), " ", _h('div', {
    staticClass: "content"
  }, [_h('span', {
    staticClass: "stress"
  }, [_vm._s(_vm.seller.deliveryTime)]), "元\n          "])])]), " ", _h('div', {
    staticClass: "favorite",
    on: {
      "click": function($event) {
        _vm.toggleFavorite($event)
      }
    }
  }, [_h('i', {
    staticClass: "iconfont icon-aixin",
    class: {
      'active': _vm.favorite
    }
  }), " ", _h('span', [_vm._s(_vm.favoriteText)])])]), " ", _h('split'), " ", _h('div', {
    staticClass: "bulletin"
  }, [_h('h1', {
    staticClass: "title"
  }, ["公告与活动"]), " ", _h('div', {
    staticClass: "content-wrapper border-1px"
  }, [_h('p', {
    staticClass: "content"
  }, [_vm._s(_vm.seller.bulletin)])]), " ", (_vm.seller.supports) ? _h('ul', {
    staticClass: "supports"
  }, [_vm._l((_vm.seller.supports), function(item, index) {
    return _h('li', {
      staticClass: "support-item"
    }, [_h('span', {
      staticClass: "icon",
      class: _vm.classMap[_vm.seller.supports[index].type]
    }), " ", _h('span', {
      staticClass: "text"
    }, [_vm._s(_vm.seller.supports[index].description)])])
  })]) : _vm._e()]), " ", _h('split'), " ", _h('div', {
    staticClass: "pics"
  }, [_h('h1', {
    staticClass: "title"
  }, ["商家实景"]), " ", _h('div', {
    ref: "picWrapper",
    staticClass: "pic-wrapper"
  }, [_h('ul', {
    ref: "picList",
    staticClass: "pic-list"
  }, [_vm._l((_vm.seller.pics), function(pic) {
    return _h('li', {
      staticClass: "pic-item"
    }, [_h('img', {
      attrs: {
        "src": pic,
        "width": "120",
        "height": "120"
      }
    })])
  })])])]), " ", _h('split'), " ", _h('div', {
    staticClass: "info"
  }, [_h('div', {
    staticClass: "title  border-1px"
  }, ["商家信息"]), " ", _h('ul', [_vm._l((_vm.seller.infos), function(info) {
    return _h('li', {
      staticClass: "info-item"
    }, [_vm._s(info)])
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.vue-loader@10.0.2/lib/template-compiler.js?id=data-v-abe470c0!./~/.vue-loader@10.0.2/lib/selector.js?type=template&index=0!./src/components/seller/seller.vue
// module id = 54
// module chunks = 1